import React, { useCallback, useEffect, useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../components/icon/iconfont";
import WhatsappSubPopup from './sub-popup/index';
import OpLoading from "../../../../components/loading/op-loading";
import { fetchRegisterCountryData } from "../../../../../api";
import Alert from "../../../../components/alert";


const SendToWhatsapp = props =>{
    const { setShow, isSubscribe } = props;

    return <div className={cls.SendToWhatsapp} onClick={() =>setShow(true)}>
        <span className={`${cls.CheckBox} ${isSubscribe ? cls.Active : ""}`}></span>

        <span className={cls.SendTo}>Send to WhatsApp</span>

        <Iconfont className={cls.WhatsIcon}>&#xe785;</Iconfont>
    </div>
}

export default props =>{
    useStyles(cls);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
	const [locations, setLocations] = useState([]);

    const [isSubscribe, setSubscribe] = useState(false);

    const onShowHandle = useCallback(async () =>{
        if(locations?.length > 0){
            setShow(true);
        }else{
            try {
                setLoading(true);
                let response = await fetchRegisterCountryData();
                if(response?.code === 200 && response?.result){
                    setLocations(response.result);
                    setShow(true);
                }else{
                    setShow(false);
                    response?.result && Alert(response.result);
                }
                setLoading(false);
            } catch (error) {
                console.log('error', error);
                setLoading(false);
                setShow(false);
            }
        }
    }, [locations]);

    return <React.Fragment>
        {
            !isSubscribe && <SendToWhatsapp setShow={onShowHandle} isSubscribe={isSubscribe} />
        }

        <WhatsappSubPopup 
            show={show} 
            locations={locations} 
            onClose={()=>setShow(false)} 
            setSubscribe={(flag)=>setSubscribe(flag)} 
            { ...props }
        />

        {
            loading && <OpLoading />
        }
    </React.Fragment>
}